import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AuthLanding from './AuthLanding';
import AdminSignUp from './AdminSignUp';
import AdminSignIn from './AdminSignIn';
import AdminForgotPassword from './AdminForgotPassword';
import MemberSignIn from './MemberSignIn';
import { supabaseClient } from '../../../shared/utils/supabaseClient';
import { resolveUserRole } from '../utils/resolveUserRole';

const Auth = () => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabaseClient.auth.getUser();
      if (user) {
        const { role } = await resolveUserRole(user.id);
        setUserRole(role);
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem('userRole');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    if (userRole === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (userRole === 'member') {
      return <Navigate to="/member/dashboard" replace />;
    }
  }

  return (
    <Routes>
      <Route path="/" element={<AuthLanding />} />
      <Route path="/signin" element={<AuthLanding />} />
      <Route path="/admin/signup" element={<AdminSignUp />} />
      <Route path="/admin/signin" element={<AdminSignIn />} />
      <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
      <Route path="/member/signin" element={<MemberSignIn />} />
      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
};

export default Auth;
